import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Content from '../views/Content.vue'
import AchievementContent from '../views/AchievementContent.vue'
import Data from '../views/Data.vue'
import Apply from '../views/Apply.vue'
import Detail from '../views/Detail.vue'
import Login from '../views/Login.vue'
import Report from '../views/Report.vue'
import {user_info} from '@/utils/api'
import store from "@/store";
import {
	getToken
} from "@/utils/auth";
Vue.use(VueRouter)

function getCookie(name) {
	var r = document.cookie.match("\\b" + name + "=([^;]*)\\b");
	return r ? r[1] : undefined;
}

const routes = [{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			keepAlive: true
		} //true缓存 false不缓存
	},
	{
		path: '/content',
		name: 'Content',
		component: Content,
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/achievement',
		name: 'Achievement',
		component: AchievementContent,
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/data',
		name: 'Data',
		component: Data,
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/apply',
		name: 'Apply',
		component: Apply,
		meta: {
			// keepAlive: true
			keepAlive: false
		}
	},
	{
		path: '/detail',
		name: 'Detail',
		component: Detail,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/report',
		name: 'Report',
		component: Report,
		meta: {
			keepAlive: false
		}
	}
]

const router = new VueRouter({
	routes
})
const whiteList = ['/login', '/', '/content','/achievement', '/detail', '/data'] // no redirect whitelist
router.beforeEach((to, from, next) => {
	if (to.path != "/login") {
		if (whiteList.indexOf(to.path) != -1) {
			next()
		} else if (getToken() || getCookie("csrftoken")) {
			user_info().then(res=>{
				store.state.username = res.name
				store.state.is_out_user = res.is_out_user
			})
			next();
		} else {
			next("/login");
		}
	} else {
		if (getToken() || getCookie("csrftoken")) {
			next("/");
		} else {
			next();
		}
	}
})
export default router
